import { Dispatch, SetStateAction, useEffect, useState, useRef } from 'react'
import cx from 'classnames'

import './style.scss'

type Props = {
  value: string
  setValue: Dispatch<SetStateAction<string>>
  length?: number
  error?: string
  clearError?: () => void
  disabled?: boolean
}

export const CodeInput = ({
  value,
  setValue,
  length = 6,
  error,
  clearError,
  disabled,
}: Props) => {
  const [showError, setShowError] = useState(false)

  const ___$input = useRef<HTMLInputElement>()

  useEffect(() => {
    setShowError(!!error)
  }, [error])

  useEffect(() => {
    window.setTimeout(() => {
      ___$input?.current?.focus?.()
    }, 200)
  }, [])

  return (
    <div className="CodeInput">
      <div className="CodeInput__wrapper">
        <div className="CodeInput__placeholder">
          {Array.from(Array(6))?.map?.((_, i) => (
            <div
              className={cx('CodeInput__placeholder__digit', {
                'CodeInput__placeholder__digit--error': showError,
              })}
              key={i}
            >
              <span className="CodeInput__placeholder__digit__span">0</span>
            </div>
          ))}
        </div>

        <input
          className="CodeInput__input"
          onChange={(e) => {
            // auto convert full width to half width
            setValue(
              e.target.value.replace(/[\uff01-\uff5e]/g, function (ch) {
                return String.fromCharCode(ch.charCodeAt(0) - 0xfee0)
              })
            )
            clearError?.()
          }}
          value={value}
          minLength={length}
          maxLength={length}
          disabled={disabled}
          ref={___$input}
        />
      </div>

      {showError && <p className="CodeInput__error-message">{error}</p>}
    </div>
  )
}
